import customAxios from "../../customAxios";
import { UPDATE_PRICE } from "../../routes";

const updateCategoryPrice = async (props: any) => {
  console?.log(props);
  const body = {
    companyPrice: props?.prices.map((item: any) => {
      return { category: item.category, price: item.price };
    }),
  };

  try {
    return (await customAxios.put(UPDATE_PRICE + `/${props.companyId}`, body))
      .data;
  } catch (error: unknown) {
    console.error({ UPDATE_CLIENT: error });
    return false;
  }
};

export default updateCategoryPrice;
